import { Link } from '@material-ui/core';
import registerTags from '~/utils/googleTags/registerTags';
import FabButton from '../DesignSystem/Fab'

export const Helper = () => {
  const handleOpenModal = () => {
    registerTags.pushHelpClickTag();
    registerTags.pushOpenModalTag({modal:"Ajuda"});
  }

  return (
    <div onClick={handleOpenModal}>
      <Link href={process.env.REACT_APP_OPEN_TICKET_URL} target="_blank" rel="noopener noreferrer">
        <FabButton />
      </Link>
    </div>
  )
}
